"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CURRENT_PROJECT_VERSION = void 0;
exports.CURRENT_PROJECT_VERSION = 11;
